// Fix lazyload crash
import '@/ebat/components/blocks/Forms/EditableField/EditableField.scss';
import '@/ebat/components/blocks/Aside/Template/Actions/Actions.scss';
import '@/ebat/components/blocks/Aside/Aside.scss';
import '@/ebat/components/blocks/Aside/Delete/Delete.scss';
import '@/ebat/components/blocks/Aside/Template/Left/Left.scss';
import '@/ebat/components/blocks/Aside/Template/Right/Right.scss';
import '@/ebat/components/blocks/Aside/AddToWishlist/AddToWishlist.scss';
import '@/ebat/components/blocks/Forms/SelectCart/SelectCart.scss';
import '@/ebat/components/blocks/Forms/AddNewCart/AddNewCart.scss';
import '@/ebat/components/blocks/Forms/QuickEntry/QuickEntry.scss';
import '@/ebat/components/blocks/Modal/Common/AddToCart/AddToCart.scss';
import '@/ebat/components/blocks/Cart/CartItem/CartItem.scss';
import '@/ebat/components/blocks/Modal/Common/SelectItems/SelectItems.scss';
import '@/ebat/components/blocks/Order/ItemsTypes/Text/Text.scss';
import '@/ebat/components/blocks/Aside/History/Item/Item.scss';
import '@/ebat/components/blocks/Aside/History/History.scss';
import '@/ebat/components/blocks/Aside/AddToCart/AddToCart.scss'

import React from 'react';

const withBuild = (Children) => (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Children {...props} />
);

export default withBuild;

